/**
 * @file Creates a shared interface for all LightApis.
 *       The LightApiInterface must be implemented by all LightApis.
 *       All described methods must be implemented.
 *
 * @module LightApiInterface
 * @author Michael Oppitz
 */

/**
 * Interface for the LightApi.
 * The LightApi implements all functionality related to the lights.
 *
 * //@interface LightApiInterface
 */
class LightApiInterface {

  // /**
  //  * The unique runtime ID for a specific light.
  //  *
  //  * @typedef {String} module:LightApiInterface~LightApiInterface#LightID
  //  */

  // /**
  //  * Light type, see {@link  module:LightApiInterface~LightApiInterface#LIGHTTYPE} for values
  //  * @typedef {String} module:LightApiInterface~LightApiInterface#LIGHTTYPE
  //  */

  // /**
  //  * The definition of a light.
  //  *
  //  * @typedef {Object} module:LightApiInterface~LightApiInterface#LightDefinition
  //  * @property {module:LightApiInterface~LightApiInterface#LightID} id the id of the light
  //  * @property {module:LightApiInterface~LightApiInterface#LIGHTTYPE} type the type of the light
  //  * @property {Number} [intensity] the intensity of the light
  //  * @property {module:ApiInterfaceV2~ApiInterfaceV2#Color} [color] the color of the light
  //  * 
  //  */


   
   
  // /**
  //  * Predefined light scenes, see {@link  module:LightApiInterface~LightApiInterface#LIGHTSCENE} for values
  //  * @typedef {String} module:LightApiInterface~LightApiInterface#LIGHTSCENE
  //  */

  // /**
  //  * The unique runtime ID for a specific light scene.
  //  *
  //  * @typedef {String} module:LightApiInterface~LightApiInterface#LightSceneID
  //  */

  // /**
  //  * The definition of a light scene.
  //  *
  //  * @typedef {Object} module:LightApiInterface~LightApiInterface#LightSceneDefinition
  //  * @property {module:LightApiInterface~LightApiInterface#LightSceneID} id the id of the light scene
  //  * @property {[module:LightApiInterface~LightApiInterface#LightDefinition]} lights the lights in the scene
  //  */




  /**
   * The constructor for the {@link module:LightApiInterface~LightApiInterface}.
   * @constructs module:LightApiInterface~LightApiInterface
   */
  constructor() {
    
    // /**
    //  * Enum for supported light types.
    //  * @readonly
    //  * @enum {module:LightApiInterface~LightApiInterface#LIGHTTYPE}
    //  */
    // this.LIGHTTYPE = {
    //   /**  ambient light */
    //   AMBIENT : 'ambient',
    //   /**  directional light */
    //   DIRECTIONAL : 'directional',
    //   /** spot light */
    //   SPOT : 'spot',
    // };

    // /**
    //  * Enum for predefined light scenes.
    //  * @readonly
    //  * @enum {module:LightApiInterface~LightApiInterface#LIGHTSCENE}
    //  */
    // this.LIGHTSCENE = {
    //   /** the default light scene */
    //   DEFAULT: 'default',
    //   /** the legacy light scene */
    //   LEGACY: 'legacy'
    // };

  }

  // /**
  //  * 
  //  * @param {LightDefinition} definition 
  //  * @returns {LightID}
  //  */
  // addLight(definition) {}

  // /**
  //  * 
  //  * @param {LightID} id 
  //  */
  // removeLight(id) {}

  // /**
  //  * @param {LightID} id 
  //  * @param {LightDefinition} definition 
  //  */
  // updateLight(id, definition) {}




  // /**
  //  * Loads a light scene.
  //  * 
  //  * @param {module:LightApiInterface~LightApiInterface#LightSceneID|module:LightApiInterface~LightApiInterface#LIGHTSCENE} id 
  //  * @returns {Boolean}
  //  */
  // loadLightScene(id) {}

  // /**
  //  * Save the current light scene either to a new {@link module:LightApiInterface~LightApiInterface#LightSceneID} or to the one provided.
  //  * 
  //  * @param {module:LightApiInterface~LightApiInterface#LightSceneID|module:LightApiInterface~LightApiInterface#LIGHTSCENE} [id] 
  //  * @returns {module:LightApiInterface~LightApiInterface#LightSceneID|module:LightApiInterface~LightApiInterface#LIGHTSCENE}
  //  */
  // saveLightScene(id) {}

  // /**
  //  * 
  //  * @param {module:LightApiInterface~LightApiInterface#LightSceneDefinition} scene 
  //  * @returns {module:LightApiInterface~LightApiInterface#LightSceneID|module:LightApiInterface~LightApiInterface#LIGHTSCENE}
  //  */
  // setLigthScene(scene) {}

  // /**
  //  * 
  //  * @param {module:LightApiInterface~LightApiInterface#LightSceneID|module:LightApiInterface~LightApiInterface#LIGHTSCENE} id 
  //  * @returns {module:LightApiInterface~LightApiInterface#LightSceneDefinition}
  //  */
  // getLightScene(id) {}
}

module.exports = LightApiInterface;
